<template>
    <p-search-screen
        title="Buyers Guide Search"
        api-destination="productquicksearch" 
        search-destination="buyersguidesearch"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        :per-page-options="[
                { value: 10, text: 'Show 10' },
                { value: 25, text: 'Show 25' },
                { value: 50, text: 'Show 50' },
                { value: 100, text: 'Show 100' }
            ]"
        disableInitialSearch
    > 
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import { currencyFormatter } from '@/components/Common/Formatters.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'BuyersGuideFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: null,
                searchBy: 'All',
                sortDesc: false
            },
            filterBy: ['All','Author','Title','ISBN','Book Key','Edition','Imprint','Copyright'],
            fields: [
                {
                    key: 'author',                    
                    sortable: true,
                    label: 'Author'
                },
                {
                    key: 'title',                  
                    sortable: true,
                    label: 'Title' 
                },
                {
                    key: 'imprint',
                    sortable: true,
                    label: 'Imprint' 
                },
                {
                    key: 'edition',
                    sortable: true,
                    label: 'Edition' 
                }, 
                {
                    key: 'copyright',
                    sortable: true,
                    label: 'Copyright' 
                }, 
                {
                    key: 'isbn',
                    sortable: true,
                    label: 'ISBN' 
                }, 
                {
                    key: 'retail',
                    sortable: true,
                    label: 'Price',
                    formatter: currencyFormatter
                }, 
                {
                    key: 'binding',
                    sortable: true,
                    label: 'Binding' 
                }, 
                {
                    key: 'buyPrice',
                    sortable: true,
                    label: 'Buyback Price',
                    formatter: currencyFormatter
                }, 
                {
                    key: 'comments',
                    label: 'Comments' 
                }, 
            ]
        };
    }
};
</script>
